export default function Preloader({ fullscreen = false }) {
  return (
    <div
      className={`${
        fullscreen
          ? "fixed inset-0 z-[9999]"
          : "w-full min-h-[300px]"
      } 
      bg-[#855109]/10 flex flex-col items-center justify-center animate-fadeIn`}
    >
      {/* Logo */}
      <img
        src="/images/logo/apnawebxlogo.png"
        alt="ApnaWebX Logo"
        className="h-24 mb-4 animate-pulse drop-shadow-xl"
      />

      {/* Ring Loader */}
      <div className="loader"></div>

      <p className="text-[#855109] text-lg mt-4 font-semibold tracking-wide">
        Loading ApnaWebX ...
      </p>
    </div>
  );
}
